import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigate, useLocation } from 'react-router-dom';
import { useScroll } from '../ScrollContext';
import logo from '../Utils/logo.png'

function Header() {

  const navigate = useNavigate();
  const location = useLocation();
  const { setScrollTarget } = useScroll();

  const handleScroll = (id) => {
    if (location.pathname !== '/') {
      setScrollTarget(id);
      navigate('/');
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const mailId = "kotharitourandtravelservices@gmail.com"
  // const fieldId ="1rXcCAxBACv5SdPrULKRyHAWu45GFSpw0";
  // const logo = `https://drive.google.com/uc?export=view&id=${fieldId}`;

  return (
    <div>
      {/* Spinner Start */}
      {/* <div
      id="spinner"
      className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
    >
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div> */}
      {/* Spinner End */}

    {/* Topbar Start */}
    <div className="container-fluid bg-dark px-5 d-none d-lg-block">
      <div className="row gx-0">
        <div className="col-lg-9 text-center text-lg-start mb-2 mb-lg-0">
          <div
            className="d-inline-flex align-items-center"
            style={{ height: 45 }}
          >
            <small className="me-3 text-light">
              <i className="fa fa-map-marker-alt me-2" />
              F-45, Jhalana Gram, Malviya Nagar, Jaipur
            </small>
            <small>
              <a href={`tel:${+919610415221}`} className="me-3 text-light">
                <i className="fa fa-phone-alt me-2 " />
                +91 9610415221
              </a>
            </small>
            <small>
              <a href={`mailto:${mailId}`} className="me-3 text-light">
                <i className="fa fa-envelope-open me-2" />
                {mailId}
              </a>
            </small>
          </div>
        </div>
        <div className="col-lg-3 text-center text-lg-end">
          <div
            className="d-inline-flex align-items-center"
            style={{ height: 45 }}
          >
            <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              to=""
            >
              <i className="fab fa-twitter fw-normal" />
            </a>
            <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              href="https://www.facebook.com/share/1XcxiyjpRp/"
              target='_blank'
            >
              <i className="fab fa-facebook-f fw-normal" />
            </a>
            {/* <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              to=""
            >
              <i className="fab fa-linkedin-in fw-normal" />
            </a> */}
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.instagram.com/kotharitourandtravels?igsh=ZXNidmN0OXdlaHB0"
                target='_blank'
              >
                <i className="fab fa-instagram fw-normal" />
              </a>
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
                to=""
              >
                <i className="fab fa-youtube fw-normal" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}
      {/* Navbar & Hero Start */}
      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-lg-0">
          <Link to="/" className="navbar-brand p-0">
            <img style={{ width: "auto", height: "90px" }} src={logo} alt="Logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars" />
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link" onClick={() => handleScroll('home')}>
                Home
              </Link>
              <Link className="nav-item nav-link" onClick={() => handleScroll('about')}>
                About
              </Link>
              <Link className="nav-item nav-link" onClick={() => handleScroll('services')}>
                Services
              </Link>
              <Link className="nav-item nav-link" onClick={() => handleScroll('packages')}>
                Packages
              </Link>
              <div className="nav-item dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Pages
                </Link>
                <div className="dropdown-menu m-0">
                  <Link className="dropdown-item" onClick={() => handleScroll('destination')}>
                    Destination
                  </Link>
                  {/* <a className="dropdown-item" onClick={() => handleScroll('booking')}>
                  Booking
                </a> */}
                  <Link className="dropdown-item" onClick={() => handleScroll('team')}>
                    Travel Guides
                  </Link>
                  {/* <a className="dropdown-item" onClick={() => handleScroll('testimonial')}>
                  Testimonial
                </a> */}
                  {/* <Link to="/Error" className="dropdown-item">
                  404 Page
                </Link> */}
                </div>
              </div>
              <Link to="/Contact" className="nav-item nav-link" onClick={() => handleScroll('home')}>
                Contact
              </Link>
            </div>
          </div>
        </nav>
      </div>
      {/* Navbar & Hero End */}
    </div>
  )
}

export default Header